import React from "react";
import { Backdrop, CircularProgress } from "@material-ui/core";
import { useStyles } from './LoadingSpinner.styles';

const LoadingSpinner = ({ show }) => {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={show}>
      <CircularProgress disableShrink />
    </Backdrop>
  );
};

export default LoadingSpinner;
